import * as Popup from "../framework/components/popup.js";

/**
 * When the event is triggered, it opens a modal popup.
 *
 * @param {String} event.detail.popup_id - The `id` for the popup that should be opened.
 */
window.addEventListener("phx:popup:open", (event) => {
  event.preventDefault();

  const popupEl = document.getElementById(event.detail.popup_id) ?? event.target.closest(".popup");
  Popup.open(popupEl);
});

/**
 * When the event is triggered, it close a modal popup.
 *
 * @param {String} event.detail.popup_id - The `id` for the popup that should be closed.
 */
window.addEventListener("phx:popup:close", (event) => {
  event.preventDefault();

  const popupEl = document.getElementById(event.detail.popup_id) ?? event.target.closest(".popup");

  Popup.close(popupEl);
});

/**
 * Set the custom validity message for an input.
 * To clear it, set the message to an empty string.
 *
 * @doc https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setCustomValidity
 *
 * @param {String} event.detail.target - The `id` of the input to set the message for
 * @param {String} event.detail.message - The message to set for the input
 */
window.addEventListener("phx:input:set_custom_validity", (event) => {
  const { target, message } = event.detail;

  const targetEl = document.querySelector(target);
  targetEl.setCustomValidity(message);
});

/**
 * Trigger an `"input"` event on an input. This will trigger the `phx-change` event
 * of LiveViews.
 *
 * @doc https://hexdocs.pm/phoenix_live_view/form-bindings.html#triggering-phx-form-events-with-javascript
 *
 * @param {String} event.detail.target - The `id` of the input to trigger the event on
 * @param {String} event.detail.message - The message to set for the input
 */
window.addEventListener("phx:input:trigger_change", (event) => {
  const { target } = event.detail;

  const targetEl = document.querySelector(target);
  targetEl.dispatchEvent(new Event("change", { bubbles: true }));
});

/**
 * Re-dispatch as a plain window event, for the shared (Alpine-based) `autocomplet_pdf_button`/
 * `documentButton` component, which builds its generation URL from an `update-generate-url-params`
 * window event rather than from its own (LiveView-ignored) markup.
 *
 * @param {Object} event.detail - The generation URL params pushed by the LiveView.
 */
window.addEventListener("phx:update-generate-url-params", (event) => {
  window.dispatchEvent(new CustomEvent("update-generate-url-params", { detail: event.detail }));
});
